module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex rounded-lg border-l border-b relative border-gray-200 bg-white flex-col shadow-lg course-group-chat-container",
    attrs: {
      "id": "course-group-chat-container"
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-2 justify-between border-b bg-white border-gray-200 px-3 pt-4 pb-3.5"
  }, [_c('div', {
    staticClass: "flex select-none items-center space-x-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('h6', {
    staticClass: "font-semibold text-gray-700 font-poppins leading-none text-base"
  }, [_vm._v("Course Chat")]), _vm._v(" "), (!_vm.chat_is_enabled) ? _c('span', {
    staticClass: "text-xs leading-tight font-poppins text-gray-400"
  }, [_vm._v("\n          Only teachers can send messages.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.chat_is_enabled && _vm.hasTeacherPermissionsInCourse) ? _c('span', {
    staticClass: "text-xs leading-tight font-poppins text-gray-400"
  }, [_vm._v("\n          Students can send messages.\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', [(_vm.hasTeacherPermissionsInCourse) ? _c('v-dropdown', {
    attrs: {
      "placement": "right"
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function() {
        return [_c('button', {
          staticClass: "hover:bg-gray-100 rounded-full w-8 h-8"
        }, [_c('i', {
          staticClass: "fas fa-ellipsis-v cursor-pointer text-gray-500 w-full flex items-center justify-center text-base"
        })])]
      },
      proxy: true
    }, {
      key: "content",
      fn: function() {
        return [_c('ul', {
          staticClass: "w-44"
        }, [_c('li', {
          staticClass: "sample space-x-2 border-b border-gray-200 group px-2.5 py-2.5 rounded-t flex items-center w-full cursor-pointer hover:bg-gray-100",
          on: {
            "click": _vm.toggleCourseChat
          }
        }, [_c('i', {
          staticClass: "fa fa-users"
        }), _vm._v(" "), (!_vm.chat_is_enabled) ? _c('span', {
          staticClass: "text-left",
          attrs: {
            "id": "remove-chat-message-id"
          }
        }, [_vm._v("Allow Students")]) : _c('span', {
          staticClass: "text-left"
        }, [_vm._v("Block Students")])]), _vm._v(" "), _c('li', {
          staticClass: "sample group px-2.5 py-2.5 flex space-x-2 items-center w-full cursor-pointer hover:bg-gray-100",
          on: {
            "click": _vm.clearAllMessages
          }
        }, [_c('i', {
          staticClass: "fas fa-trash-alt ml-0.5"
        }), _vm._v(" "), _c('span', {
          staticClass: "text-left",
          attrs: {
            "id": "remove-chat-message-id"
          }
        }, [_vm._v("Clear All Messages")])])])]
      },
      proxy: true
    }], null, false, 1141621643)
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    ref: "groupChatMessages",
    staticClass: "flex w-full relative flex-grow h-full mb-4 overflow-y-auto",
    attrs: {
      "id": "group-chat-messages"
    },
    on: {
      "scroll": _vm.scrollOnGroupChat
    }
  }, [(_vm.show_component) ? _c('div', {
    staticClass: "w-full px-3"
  }, _vm._l((_vm.messages), function(message, index) {
    return _c('div', {
      key: index,
      staticClass: "w-full",
      attrs: {
        "id": ("message-" + (message.id))
      }
    }, [(index === 0) ? _c('div', {
      staticClass: "flex items-center w-full space-x-2 py-4 justify-center select-none"
    }, [_c('span', {
      staticClass: "font-poppins text-xs text-gray-500"
    }, [_vm._v(_vm._s(_vm._f("day")(message.created_at)))])]) : (_vm.isDifferentDay(index)) ? _c('div', {
      staticClass: "flex items-center py-4 space-x-2 w-full justify-center select-none"
    }, [_c('span', {
      staticClass: "font-poppins text-xs text-gray-500"
    }, [_vm._v(_vm._s(_vm._f("day")(message.created_at)))])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.getProfile.id === message.user.id) ? _c('div', {
      staticClass: "py-2"
    }, [(!_vm.getTeachers(message.user.id)) ? _c('div', {
      staticClass: "flex justify-between items-center space-x-2"
    }, [_c('div', [_c('span', {
      staticClass: "text-xs text-gray-400"
    }, [_vm._v(_vm._s(_vm._f("time")(message.created_at)))])]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center space-x-2"
    }, [_c('span', {
      staticClass: "font-poppins text-gray-700"
    }, [_vm._v(_vm._s(message.user.name))]), _vm._v(" "), _c('img', {
      staticClass: "rounded-full w-7 h-7",
      attrs: {
        "src": message.user.avatar_url
      }
    })])]) : _c('div', {
      staticClass: "flex items-center justify-between space-x-2"
    }, [_c('div', [_c('span', {
      staticClass: "text-xs text-gray-400"
    }, [_vm._v(_vm._s(_vm._f("time")(message.created_at)))])]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center space-x-2"
    }, [_c('span', {
      staticClass: "font-poppins text-gray-700"
    }, [_vm._v(_vm._s(message.user.name) + " (Teacher)")]), _vm._v(" "), _c('img', {
      staticClass: "rounded-full w-7 h-7",
      attrs: {
        "src": message.user.avatar_url
      }
    })])])]) : _c('div', {
      staticClass: "py-2"
    }, [(!_vm.getTeachers(message.user.id)) ? _c('div', {
      staticClass: "flex justify-between items-center space-x-2"
    }, [_c('div', {
      staticClass: "flex items-center space-x-2"
    }, [_c('img', {
      staticClass: "rounded-full w-7 h-7",
      attrs: {
        "src": message.user.avatar_url
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "font-poppins text-gray-700"
    }, [_vm._v(_vm._s(message.user.name))])]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "text-xs text-gray-400"
    }, [_vm._v(_vm._s(_vm._f("time")(message.created_at)))])])]) : _c('div', {
      staticClass: "flex items-center justify-between space-x-2"
    }, [_c('div', {
      staticClass: "flex items-center space-x-2"
    }, [_c('img', {
      staticClass: "rounded-full w-7 h-7",
      attrs: {
        "src": message.user.avatar_url
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "font-poppins text-gray-700"
    }, [_vm._v(_vm._s(message.user.name) + " (Teacher)")])]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "text-xs text-gray-400"
    }, [_vm._v(_vm._s(_vm._f("time")(message.created_at)))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "w-full relative",
      on: {
        "mouseenter": function($event) {
          return _vm.hoverMessage(message.id)
        },
        "mouseleave": function($event) {
          _vm.hovered = false
        }
      }
    }, [(_vm.getProfile.id === message.user.id) ? _c('div', {
      staticClass: "flex justify-end space-x-2 items-center"
    }, [(_vm.hasTeacherPermissionsInCourse && message.id === _vm.hovered) ? _c('button', {
      staticClass: "w-7 h-7 rounded-full hover:bg-gray-100",
      attrs: {
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteChatMessage(message.id)
        }
      }
    }, [_c('i', {
      staticClass: "fas text-xs fa-trash-alt cursor-pointer text-red-500"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "message-container break-words rounded-tr-none rounded-tl-xl rounded-b-xl px-3 py-2 text-white font-poppins w-10/12",
      domProps: {
        "innerHTML": _vm._s(message.content)
      }
    })]) : _c('div', {
      staticClass: "flex justify-start items-center space-x-2"
    }, [_c('div', {
      staticClass: "bg-gray-100 break-words rounded-tl-none rounded-tr-xl rounded-b-xl px-3 py-2 text-gray-700 font-poppins w-10/12",
      domProps: {
        "innerHTML": _vm._s(message.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex flex-col"
    }, [(_vm.hasTeacherPermissionsInCourse && message.id === _vm.hovered) ? _c('button', {
      staticClass: "w-7 h-7 rounded-full hover:bg-gray-100",
      attrs: {
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          return _vm.deleteChatMessage(message.id)
        }
      }
    }, [_c('i', {
      staticClass: "fas text-xs fa-trash-alt cursor-pointer text-red-500"
    })]) : _vm._e()])])])])
  }), 0) : _c('div', {
    staticClass: "flex flex-col w-full h-full items-center justify-center"
  }, [_c('pl-spinner', {
    staticClass: "flex justify-center"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex w-full justify-between items-center space-x-2 px-3 pb-3.5"
  }, [(_vm.long_message) ? _c('div', {
    staticClass: "text-pinky ml-3 text-left"
  }, [_vm._v("\n      This message is too long\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex w-full justify-between items-center"
  }, [_c('textbox', {
    staticClass: "rounded border placeholder:text-gray-100 h-16 max-h-14 w-10/12 focus-within:border-primary",
    attrs: {
      "placeholder": "Leave a message",
      "maxHeight": 56,
      "theme": "muted-focus",
      "showSubmitButton": false,
      "fillRemaining": true,
      "focusOnMounted": true,
      "enableShiftEnter": true,
      "allowEmoji": true,
      "chatIsEnabled": _vm.hasTeacherPermissionsInCourse ? true : _vm.chat_is_enabled,
      "disabled": (!_vm.hasTeacherPermissionsInCourse && !_vm.chat_is_enabled) || _vm.getCourseDetail.is_sample === true
    },
    on: {
      "enter": _vm.sendChatMessage
    },
    model: {
      value: (_vm.chat_message),
      callback: function($$v) {
        _vm.chat_message = $$v
      },
      expression: "chat_message"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w-10"
  }, [_c('button', {
    staticClass: "message-container text-white flex justify-center items-center rounded-full h-9 w-9",
    attrs: {
      "disabled": _vm.chat_message.trim() === '',
      "title": "Send Message"
    },
    on: {
      "click": _vm.sendChatMessage
    }
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": require("../../../../../static/course/send_message.svg")
    }
  })])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-white rounded-full h-10 w-10 flex items-center justify-center border border-gray-200"
  }, [_c('img', {
    staticClass: "w-5 h-5",
    attrs: {
      "src": require("../../../../../static/course/message-chat-circle.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3c2fc86a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/components/CourseChatBubble.vue
// module id = 1891
// module chunks = 61